export const LOCALES = {
  'en': 'English',
  'de': 'German',
  'pl': 'Polish',
  'fr': 'French',
  'it': 'Italian',
  //'es': 'Spanish',
  'es-MX': 'Spanish (Mexico)',
  'es-ES': 'Spanish (Spain)',
  'hi': 'Hindi',
  'ko': 'Korean',
  //'pt': 'Portuguese',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-PT': 'Portuguese (Portugal)',
  'ru': 'Russian',
  'uk': 'Ukrainian',
  'he': 'Hebrew',
  'no': 'Norwegian',
  'ro': 'Romanian',
  'ja': 'Japanese',
  'zh': 'Chinese (Simplified)',
  //'zh-Hans': 'Chinese (Simplified Han)',
}
